import { Map } from '@popety_io/popety-io-lib'
import { API_BASE_URL } from '../../../../../services'
import {
  ESTIMATE_PURCHASE_APARTMENT,
  ESTIMATE_VALUE_FIELD,
  MIN_PRICE_RENT,
  MIN_PRICE_PURCHASE,
  MAX_PRICE_PURCHASE,
  MAX_PRICE_RENT,
} from '../../../../../config'

const renderMethod = 'aggs'

const sourceName = 'es_mvt_pricing'
const fillStyle = 'layer_fill_pricing'

const removePricingTiles = ({ map }: { map: Map }) => {
  if (map.getSource(sourceName)) {
    map.removeLayer(fillStyle)
    map.removeSource(sourceName)
  }
}

const getPricingTiles = ({
  map,
  indexName = ESTIMATE_PURCHASE_APARTMENT,
  geoCenter,
  geometryFieldName = 'geo_center',
}: {
  map: Map
  indexName?: string
  geometryFieldName?: string
  geoCenter?: string
}) => {
  try {
    if (map.getSource(sourceName)) {
      map.removeLayer(fillStyle)
      map.removeSource(sourceName)
    }

    map.addSource(sourceName, {
      type: 'vector',
      tiles: [
        `${API_BASE_URL}/public/pricing/tiles?valueField=${ESTIMATE_VALUE_FIELD}&index=${indexName}&field=${geometryFieldName}&renderMethod=${renderMethod}&geoCenter=${geoCenter}&x={x}&y={y}&z={z}`,
      ],
      minzoom: 0,
      maxzoom: 24,
    })

    const regex = /rent/
    const fillOpacity = 0.5
    const min = regex.test(indexName) ? MIN_PRICE_RENT : MIN_PRICE_PURCHASE
    const max = regex.test(indexName) ? MAX_PRICE_RENT : MAX_PRICE_PURCHASE
    const diff = max - min

    map.addLayer({
      id: fillStyle,
      type: 'fill',
      source: sourceName,
      'source-layer': renderMethod,
      paint: {
        'fill-outline-color': 'transparent',
        'fill-opacity': fillOpacity,
        'fill-color': {
          property: 'avg_price_m2.value',
          stops: [
            [min, '#5e4fa2'],
            [min + Math.round(diff / 8) * 1, '#3288bd'],
            [min + Math.round(diff / 8) * 2, '#66c2a5'],
            [min + Math.round(diff / 8) * 3, '#abdda4'],
            [min + Math.round(diff / 8) * 4, '#e6f598'],
            [min + Math.round(diff / 8) * 5, '#fee08b'],
            [min + Math.round(diff / 8) * 6, '#fdae61'],
            [min + Math.round(diff / 8) * 7, '#f46d43'],
            [min + Math.round(diff / 8) * 8, '#d53e4f'],
            [max, '#9e0142'],
          ],
        },
      },
    })
  } catch (error) {
    console.error(error)
  }
}

export { removePricingTiles, getPricingTiles }
